import { createClient } from "@/shared/urql/urql";
import {
  RegisterFleetAtHomeUserDocument,
  type FleetAtHomeRegistrationDataInput,
} from "@/shared/generated/graphql";

export const registerFleetAtHomeUser = async (
  registrationData: FleetAtHomeRegistrationDataInput,
) => {
  const urqlClient = createClient();

  const { error, data } = await urqlClient
    .mutation(RegisterFleetAtHomeUserDocument, {
      registrationData,
    })
    .toPromise();
  if (error) throw error;

  return data?.registerFleetAtHomeUser;
};
